// This file exists purely to make unit testing easier

export function redirectToUrl(url) {
    window.location = url;
}
